import { ChatComponent } from './content/chat.component';
import { CommunityGuard } from './guards/community.guard';
import { LayoutComponent } from './modules/layout/layout.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Routes } from '@angular/router';

const routes: Routes = [
  {
    path: ':id',
    component: LayoutComponent,
    canActivate: [CommunityGuard],

    children: [
      {
        path: '',
        redirectTo: 'analytics',
        pathMatch: 'full',
      },
      {
        path: 'newsletter',
        loadChildren: () =>
          import('./modules/newsletter/newsletter.module').then(
            m => m.NewsletterModule
          ),
      },
      {
        path: 'residents',
        loadChildren: () =>
          import('./modules/resident/resident.module').then(
            m => m.ResidentModule
          ),
      },
      {
        path: 'staff',
        loadChildren: () =>
          import('./modules/interviewer/interviewer.module').then(
            m => m.InterviewerModule
          ),
      },
      {
        path: 'calendar',
        loadChildren: () =>
          import('./modules/calendar/calendar.module').then(
            m => m.CalendarModule
          ),
      },
      {
        path: 'clubs',
        loadChildren: () =>
          import('./modules/clubs/clubs.module').then(m => m.ClubsModule),
      },
      {
        path: 'actionable-insights',
        loadChildren: () =>
          import(
            './modules/actionable-insights/actionable-insights.module'
          ).then(m => m.ActionableInsightsModule),
      },
      {
        path: 'analytics',
        loadChildren: () =>
          import('./modules/analytics/analytics.module').then(
            m => m.AnalyticsModule
          ),
      },
      {
        path: 'marketing-insights',
        loadChildren: () =>
          import('./modules/marketing-insights/marketing-insights.module').then(
            m => m.MarketingInsightsModule
          ),
      },
      {
        path: 'quality-of-life',
        loadChildren: () =>
          import('./modules/quality-of-life/quality-of-life.module').then(
            m => m.QualityOfLifeModule
          ),
      },
      {
        path: 'family-app-notification',
        loadChildren: () =>
          import('./modules/announcements/announcements.module').then(
            m => m.AnnouncementsModule
          ),
      },
      {
        path: 'chat',
        component: ChatComponent,
      },
      {
        path: 'attendance-report',
        loadChildren: () =>
          import('./modules/attendance-report/attendance-report.module').then(
            m => m.AttendanceReportModule
          ),
      },
      {
        path: 'uploads',
        data: {
          dropzone: true,
          title: 'UPLOADS',
        },
        loadChildren: () =>
          import('../administration/modules/files/files.module').then(
            m => m.FilesModule
          ),
      },
      {
        path: 'attendance-report-chart',
        loadChildren: () =>
          import(
            './modules/attendance-report-chart/attendance-report-chart.module'
          ).then(m => m.AttendanceReportChartModule),
      },
      {
        path: 'gallery',
        loadChildren: () =>
          import('./modules/gallery/gallery.module').then(m => m.GalleryModule),
      },
      {
        path: 'family',
        loadChildren: () =>
          import('./modules/family/family.module').then(m => m.FamilyModule),
      },
      {
        path: 'engagement-metrics',
        loadChildren: () =>
          import('./modules/engagement-metrics/engagement-metrics.module').then(
            m => m.EngagementMetricsModule
          ),
      },
      {
        path: 'search',
        loadChildren: () =>
          import('../core/modules/search/search.module').then(
            m => m.SearchModule
          ),
      },
      {
        path: 'digital-signage',
        loadChildren: () =>
          import('./modules/digital-signage/digital-signage.module').then(
            m => m.DigitalSignageModule
          ),
      },
      {
        path: 'content',
        loadChildren: () =>
          import('./modules/content/content.module').then(m => m.ContentModule),
      },
      {
        path: 'tribune',
        loadChildren: () =>
          import('./modules/content/modules/tribune/tribune.module').then(
            m => m.TribuneModule
          ),
      },
      {
        path: 'feed-back',
        loadChildren: () =>
          import('../core/modules/feed-back/feed-back.module').then(
            m => m.FeedBackModule
          ),
      },
      {
        path: 'sales-tool',
        loadChildren: () =>
          import('../core/modules/sales-tool/sales-tool.module').then(
            m => m.SalesToolModule
          ),
      },
      {
        path: 'transportation',
        loadChildren: () =>
          import('./modules/transportation/transportation.module').then(
            m => m.TransportationModule
          ),
      },
      {
        path: 'dining-calendar',
        loadChildren: () =>
          import('./modules/dining-calendar/dining-calendar.module').then(
            m => m.DiningCalendarModule
          ),
      },
      {
        path: 'compliance',
        pathMatch: 'prefix',
        loadChildren: () =>
          import(
            '../core/modules/enterprise-management/enterprise-management-routing.module'
          ).then(m => m.EnterpriseManagementRoutingModule),
      },
      {
        path: 'downloads',
        loadChildren: () =>
          import('./modules/downloads/downloads.module').then(
            m => m.DownloadsModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CommunitiesRoutingModule {}
